import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { SpinnerComponent } from "../../../lib/spinner";
import { GetFileByIdToZip, resetGetFileByIdStatus, resetGetFileByIdToZipResponses, resetGetFileByIdToZipStatus, setGetFileByIdToZipRequest } from "../../../objectStorage/slice";
import { downloadZip } from "../../../objectStorage/utils";
import { DownloadIcon } from "../../../ui/icons/DownloadIcon";
import { MagnifyingIcon } from "../../../ui/icons/magnifying";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { Calendar } from "../../../ui/molecules/calendar";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { formatterDate, OptionType, yearOptions } from "../../../utils";
import { GetAllEntryProtocolAttachments, GetAllEntryProtocolObjects, GetAllEntryProtocols, resetGetAllEntryProtocolAttachmentsStatus, resetGetAllEntryProtocolObjectsStatus, resetGetAllEntryProtocolsStatus, resetGetAllEPFiltersDocuments, setGetAllEPFilterAttachmentId, setGetAllEPFilterClient, setGetAllEPFilterObjectId, setGetAllEPFilterObjectSpec, setGetAllEPFilterProtocolDay, setGetAllEPFilterYear } from "../../protocol/entry/slice";
import { DetailsPopup } from "../detailsPopup";
import { setEntryResponseSelected } from "../slice";

interface Props {
    selectedCustomer: string
}

export function EntryDocuments(props: Props) {
    const dispatch = useAppDispatch()

    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const objectStorageState = useAppSelector(state => state.objectStorage)

    const [fileName, setFileName] = useState<string | null>(null)
    const [objects, setObjects] = useState<OptionType[]>([])
    const [attachments, setAttachments] = useState<OptionType[]>([])
    const [protocolName, setProtocolName] = useState<string | undefined>(undefined)
    const [showPopupEntry, setShowPopupEntry] = useState<boolean>(false)

    const entryProtocols = entryProtocolState.getAllEntryProtocolsResponse?.data ?? []

    const handleAtts = (subs: string[]) => {
        if (subs === null)
            return '';
        return subs.slice(0, -1)
            .map(s => `${s} - `)
            + subs[subs.length - 1]
    }

    const handleOnDownload = (fileIds: string[]) => {
        dispatch(resetGetFileByIdToZipResponses())
        dispatch(setGetFileByIdToZipRequest(fileIds))
    }

    // useEffect(() => {
    //     if (objectStorageState.getFileObjectByIdStatus === 'successfully') {
    //         // dispatch(setUpdatedFile(objectStorageState.getFileObjectByIdResponse))
    //     }

    // }, [objectStorageState.getFileObjectByIdStatus])

    useEffect(() => {
        dispatch(setGetAllEPFilterClient(props.selectedCustomer))
        dispatch(GetAllEntryProtocolObjects())
        dispatch(GetAllEntryProtocolAttachments({
            itemsPerPage: 0,
            page: 0,
        }))

    }, [])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolFilters.client) {
            dispatch(GetAllEntryProtocols(entryProtocolState.getAllEntryProtocolFilters))
        }
    }, [entryProtocolState.getAllEntryProtocolFilters.client])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolsStatus === 'successfully') {
            dispatch(resetGetAllEntryProtocolsStatus())
        }
    }, [entryProtocolState.getAllEntryProtocolsStatus])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolObjectsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolObjectsStatus())
            const data = entryProtocolState.getAllEntryProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [entryProtocolState.getAllEntryProtocolObjectsStatus])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolAttachmentsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolAttachmentsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolAttachmentsStatus())
            const data = entryProtocolState.getAllEntryProtocolAttachmentsResponse
            const newAtts: OptionType[] = data.data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setAttachments(newAtts)
        }
    }, [entryProtocolState.getAllEntryProtocolAttachmentsStatus])

    useEffect(() => {
        if (objectStorageState.getFileByIdStatus === 'successfully') {
            dispatch(resetGetFileByIdStatus())
            const base64Data = objectStorageState.getFileByIdResponse?.base64;
            if (base64Data && base64Data !== '') {
                const byteCharacters = atob(base64Data);
                const byteNumbers = Uint8Array.from(byteCharacters, char => char.charCodeAt(0));
                const blob = new Blob([byteNumbers], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);

                // Apri una finestra popup con un titolo personalizzato
                const newWindow = window.open('', '_blank', 'width=800,height=600');
                if (newWindow) {
                    newWindow.document.title = fileName!;
                    const iframe = newWindow.document.createElement('iframe');
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.src = url;
                    newWindow.document.body.appendChild(iframe);
                }
            }
        }
    }, [objectStorageState.getFileByIdStatus]);

    useEffect(() => {
        if (objectStorageState.getFileByIdToZipRequest.length < 1) {
            if (objectStorageState.getFileByIdToZipResponses.length > 0) {
                const download = async () => await downloadZip(objectStorageState.getFileByIdToZipResponses, protocolName)
                download()
                    .finally(() => dispatch(resetGetFileByIdToZipResponses()))
            }
            return
        }

        // [request.length > 0]
        const fileId = objectStorageState.getFileByIdToZipRequest[0]
        dispatch(GetFileByIdToZip(fileId))
    }, [objectStorageState.getFileByIdToZipRequest])

    useEffect(() => {
        if (objectStorageState.getFileByIdToZipStatus === 'successfully') {
            dispatch(resetGetFileByIdToZipStatus())
            if (objectStorageState.getFileByIdToZipRequest.length > 0) {
                dispatch(setGetFileByIdToZipRequest(objectStorageState.getFileByIdToZipRequest.slice(1)))
            }
        }
    }, [objectStorageState.getFileByIdToZipStatus])

    return (
        <div className="flex flex-col gap-4 p-6 min-w-0">
            <div className="w-full flex flex-row gap-2 items-center">
                <div className="flex flex-row items-center gap-2 w-full">
                    <div className="w-full flex flex-row gap-2 items-center">
                        <Calendar
                            placeholder="Data"
                            selected={entryProtocolState.getAllEntryProtocolFilters.protocolDate}
                            onChange={(date) => dispatch(setGetAllEPFilterProtocolDay(date))}
                        />
                        <MadfarmStaticSelect
                            noOptionsMessage="Nessun risultato trovato"
                            placeholder={'Anno'}
                            value={entryProtocolState.getAllEntryProtocolFilters.year}
                            options={yearOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null;
                                dispatch(setGetAllEPFilterYear(newValue))
                            }}
                        />
                        <MadfarmStaticSelect
                            noOptionsMessage="Nessun risultato trovato"
                            value={entryProtocolState.getAllEntryProtocolFilters.objectId}
                            placeholder={'Seleziona Oggetto'}
                            options={objects}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null;
                                dispatch(setGetAllEPFilterObjectId(newValue))
                            }}
                        />
                        <MadfarmInput
                            placeholder="Specifiche"
                            onChangeText={(text) => { dispatch(setGetAllEPFilterObjectSpec(text)) }}
                        />
                        <MadfarmStaticSelect
                            noOptionsMessage="Nessun allegato trovato"
                            value={entryProtocolState.getAllEntryProtocolFilters.attachmentId}
                            placeholder={'Seleziona Allegato'}
                            options={attachments}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null;
                                dispatch(setGetAllEPFilterAttachmentId(newValue))
                            }}

                        />
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Pulisci"
                            color={"gray"}
                            onClick={() => {
                                dispatch(resetGetAllEPFiltersDocuments())
                                dispatch(setGetAllEPFilterClient(props.selectedCustomer))
                            }}
                        />
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Cerca"
                            color={"orange"}
                            onClick={() => dispatch(GetAllEntryProtocols(entryProtocolState.getAllEntryProtocolFilters))}
                        />
                    </div>
                </div>
            </div>
            <div className="w-full py-6">
                {entryProtocolState.getAllEntryProtocolsStatus === 'loading' ? (
                    <div className="w-full min-h-[320px] flex items-center justify-center rounded-xl border border-neutral-200 shadow-sm bg-white">
                        <SpinnerComponent size="medium" />
                    </div>
                ) : (
                    <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                        <table className="w-full border-collapse text-sm">
                            <thead>
                                <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Azione</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Sede</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Anno</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Numero</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Nome Cliente</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Oggetto</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Oggetto Extra</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Allegati</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Principale</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Funzionario</th>
                                    <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[80px]"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {entryProtocols.length === 0 ? (
                                    <tr>
                                        <td colSpan={12} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                            Nessun protocollo trovato
                                        </td>
                                    </tr>
                                ) : (
                                    entryProtocols.map((protocol, index) =>
                                        <tr
                                            key={index}
                                            className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                        >
                                            <td className="px-3 py-2 w-[60px]">
                                                <div className="flex items-center justify-center gap-2">
                                                    <button
                                                        className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                        onClick={() => {
                                                            dispatch(setEntryResponseSelected(protocol))
                                                            setShowPopupEntry(true)
                                                        }}>
                                                        <MagnifyingIcon color={"Orange"} size={18} />
                                                    </button>
                                                    {
                                                        Array.isArray(protocol.attachmentFile) && protocol.attachmentFile.length > 0 ? (
                                                            <button
                                                                className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                                onClick={() => {
                                                                    setProtocolName(`${protocol.headQuarter} E${protocol.protocolNumber}`)
                                                                    handleOnDownload([
                                                                        ...protocol.attachmentFile
                                                                            .map(attF => attF.fileInfo?.fileId)
                                                                            .filter((fileId): fileId is string => Boolean(fileId)),
                                                                        ...(protocol.fileId ? [protocol.fileId] : [])
                                                                    ])
                                                                }}>
                                                                <DownloadIcon size="30" color={"Orange"} />
                                                            </button>
                                                        ) : null
                                                    }
                                                </div>
                                            </td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.headQuarter}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(protocol.protocolDate)}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.year}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.protocolNumber}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.sender}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{`${protocol.entryObject.description} [${protocol.entryObject.coding}]`}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.objectSpec || '-'}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{Array.isArray(protocol.entryAttachments) && protocol.entryAttachments.length > 0 ?
                                                handleAtts(protocol.entryAttachments.map(att => `[${att.coding}]`)) : '-'}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.linkExistingProtocol || '-'}</td>
                                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{`${protocol.user.name} ${protocol.user.surname}`}</td>
                                            <td className="px-3 py-2"></td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
                {/* <Pagination
                        numbResults={usersState.getUsersResponse ? usersState.getUsersResponse?.total : 0}
                        detailsResults={'utenti'}
                        pages={usersState.getUsersResponse?.totalPage || 1}
                        currentPage={usersState.filters.page} setPage={(page) => dispatch(setFindAllUsersFiltersPage(page))}
                    /> */}
                {
                    showPopupEntry && (
                        <PopupForm title="Dettagli Protocollo" headerGreen={true} close={() => {
                            setShowPopupEntry(false)
                        }}>
                            <DetailsPopup type="entry" close={() => {
                                setShowPopupEntry(false)
                            }} />
                        </PopupForm>
                    )
                }
            </div>
        </div>
    )
}